import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  Field,
  Form,
  FormElement,
  //   FormRenderProps,
} from "@progress/kendo-react-form";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { clearFilter, setFilter } from "./portdataimportSlice";
import { closeDialog } from "../../components/dialog/dialogSlice";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { clearCurrentPage } from "../pagination/paginationSlice";
import FormTextField from "../../components/formFields/FormTextField";
import { getAllPortDataimport } from "./services/portDataimport";

const PortFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const [formKey, setFormKey] = React.useState(1);

  const { currentPage, pageLimit } = useAppSelector(
    (state: RootState) => state.pagination
  );
  const initialValues = useAppSelector(
    (state: RootState) => state.portdata.filter
  );
  const dialogName = useAppSelector(
    (state: RootState) => state.dialog.dialogName
  );
  const isFilterSet = useAppSelector(
    (state: RootState) => state.portdata.isFilterSet
  );

  const handleClearFilters = () => {
    if (isFilterSet) {
      dispatch(clearFilter());
      const data = {
        limit: pageLimit,
        skip: currentPage * pageLimit,
      };
      dispatch(getAllPortDataimport(data));
    }
    setFormKey(formKey + 1);
  };

  const handleSubmit = (values: any) => {
    const formdata = {
      sb_no: values?.sb_no,
      sb_date: values?.sb_date
        ? moment(values?.sb_date).format("YYYY-MM-DD")
        : "",
      leo_date: values?.leo_date
        ? moment(values?.leo_date).format("YYYY-MM-DD")
        : "",
      lec: values?.lec,
      exporter_name: values?.exporter_name,
      consignee_name: values?.consignee_name,
      country_of_destination: values?.country_of_destination,
      port_of_discharge: values?.port_of_discharge,
      limit: pageLimit,
      skip: currentPage * pageLimit,
    };

    dispatch(
      setFilter({
        sb_no: values?.sb_no,
        sb_date: values?.sb_date,
        leo_date: values?.leo_date,
        lec: values?.lec,
        exporter_name: values?.exporter_name,
        consignee_name: values?.consignee_name,
        country_of_destination: values?.country_of_destination,
        port_of_discharge: values?.port_of_discharge,
        limit: pageLimit,
        skip: currentPage * pageLimit,
      })
    );
    dispatch(clearCurrentPage());
    dispatch(getAllPortDataimport(formdata))
      .unwrap()
      .then(() => {
        dispatch(closeDialog());
      })
      .catch(() => {
        dispatch(closeDialog());
      });
  };

  return (
    <>
      {dialogName === "PortFilter" && (
        <AppDialog>
          <Form
            key={formKey}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            render={() => (
              <FormElement style={{ width: "40vw" }}>
                <Typography.h5 style={{ margin: 0 }}>{"Filter"}</Typography.h5>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "50%" }, { width: "50%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      name="sb_no"
                      label="SB No"
                      placeholder="SB No"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="sb_date"
                      label="SB Date"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="leo_date"
                      label="LEO Date"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="lec"
                      label="LEC"
                      placeholder="LEC"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="exporter_name"
                      label="Exporter Name"
                      placeholder="Exporter Name"
                      component={FormTextField}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="consignee_name"
                      label="Consignee Name"
                      placeholder="Consignee Name"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="country_of_destination"
                      label="Country of Destination"
                      placeholder="Country of Destination"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="port_of_discharge"
                      label="Port of Discharge"
                      placeholder="Port of Discharge"
                      component={FormTextField}
                    />
                  </GridLayoutItem>

                  {/* <FilterWatcher formRenderProps={formRenderProps} /> */}
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      height: "50px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <DialogCloseButton text="Cancel" />
                    <Button
                      style={{
                        marginRight: 8,
                        marginLeft: 4,
                      }}
                      onClick={handleClearFilters}
                      type="button"
                      themeColor={"primary"}
                      fillMode="outline"
                    >
                      Clear
                    </Button>
                    <Button
                      fillMode={"solid"}
                      themeColor={"primary"}
                      type="submit"
                    >
                      Apply
                    </Button>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </AppDialog>
      )}
    </>
  );
};

export default PortFilter;
